export enum RegistrationGaPageName {
  ApplianceDetails = 'appliance-registration',
  Confirmation = 'registration-confirmation',
  ExtraApplianceDetails = 'multi-appliance-registration',
  OrderConfirmation = 'order-confirmation',
  PersonalDetails = 'personal-details',
  ProtectionAdditionalQuoteModal = 'upsell-fixed-term-pop-up',
  ProtectionDetails = 'offer-page',
}
